// Sidebar route metadata
export class RouteInfo {
  public order = 0;
  public exactMatch = true;
  public submenu: RouteInfo[] = [];
  public cssClass = '';
  public isExternalLink = false;
  public badge = '';
  public badgeClass = '';
  public type: string[] = ['all'];

  // Para que al hacer click en el parent del menu, vaya a su URL
  public parentClick = false;

  constructor(
    public path: string,
    public title: string,
    public icon: string = ''
  ) {

  }

  /**
   * Agregar para que tipos de cuenta se muestra el menu
   *
   */
  addTypes(value: string[]): RouteInfo {
    this.type = value;
    return this;
  }

  /**
   * Agregar Orden
   *
   */
  addOrder(value: number): RouteInfo {
    this.order = value;
    return this;
  }

  /**
   * Para asignar un icono al menu
   *
   */
  addIcon(value: string): RouteInfo {
    this.icon = value;
    return this;
  }

  /**
   * Para decir si es exacto o no el match
   *
   */
  exact(value: boolean): RouteInfo {
    this.exactMatch = value;
    return this;
  }

  /**
   * Agregar submenu al menu
   *
   */
  addSubMenu(value: RouteInfo[]): RouteInfo {
    this.submenu = this.submenu.concat(value);
    this.cssClass += 'has-sub';

    // Si el submenu no trae order, se ordena de acuerdo a los indices
    value.forEach((value1, index) => {
      if (value[index].order === 0) {
        value[index].order = index;
      }
    });

    return this;
  }

  /**
   * Agregar una clase css al menu
   *
   */
  addClass(value: string): RouteInfo {
    this.cssClass += ' ' + value;
    return this;
  }

  /**
   * Setear si el menu es un link externo
   *
   */
  setExternal(value: boolean): RouteInfo {
    this.isExternalLink = value;
    return this;
  }

  /**
   * Setear badges
   *
   */
  setBadges(badge: string, badgeClass: string): RouteInfo {
    this.badge = badge;
    this.badgeClass = badgeClass;
    return this;
  }

  /**
   * Agregar submenues para ABMs
   */
  addCrudSubMenu(path?: string): RouteInfo {

    if (path === undefined) {
      path = this.path;
    }

    this.exact(false);
    this.parentClick = true;
    return this.addSubMenu([
      new RouteInfo(path, 'Listado')
        .addIcon('ft-menu'),
      new RouteInfo(path + '/add', 'Agregar')
        .addIcon('ft-plus'),
    ]);
  }

}
